import React from 'react';
import PropTypes from 'prop-types';

import { CONTRIBUTOR_PERMISSION_CHECK_TYPE } from '../../../../../constants/contributors';
import ContributorFeatureBlock from './ContributorFeatureBlock';

const propTypes = {
  condition: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  entityId: PropTypes.string,
  fallbackContent: PropTypes.any,
};

const NoContributorPermissionBlock = ({ entityId, children, ...props }) => {
  const noContributorPermissionProps = {
    checkType: CONTRIBUTOR_PERMISSION_CHECK_TYPE.NO_CONTRIBUTOR,
    entityId,
  };

  return (
    <ContributorFeatureBlock
      {...props}
      contributorPermissionProps={noContributorPermissionProps}
    >
      {children}
    </ContributorFeatureBlock>
  );
};

NoContributorPermissionBlock.propTypes = propTypes;

export default NoContributorPermissionBlock;
